import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from '@ngrx/store';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { setErrorMsg } from 'src/app/kiosk/components/error/state/error.actions';
import { eKioskError } from "src/app/shared/models/api/constants";
import { AppState } from 'src/app/state/app.state';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
	constructor(public router: Router, private store: Store<AppState>) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error) => {
				if (error instanceof HttpErrorResponse) {
					// handle HTTP errors
					switch (error.status) {
						case 400:
						case 404:
							// this.store.dispatch(setErrorMsg({ data: error.error.message, noTranslation: !error.error.translate }));
							break;
						case 401:
						case 403:
							// do something else
							this.store.dispatch(setErrorMsg({ data: 'Permission issue ' + error.message, noTranslation: true }));
							break;
						case 500:
							//server error
							if (error?.message)
								this.store.dispatch(setErrorMsg({ data: error?.message, noTranslation: true }));
							else
								this.store.dispatch(setErrorMsg({ data: null, KioskError:eKioskError.TECHNICAL_ERROR }));
							break;
						default:
							//eKioskError[eKioskError.API_NOT_AVAILABLE]
							this.store.dispatch(setErrorMsg({
								data: 'The Assurcard server is not available<br/><br/>La liaison avec le serveur AssurCard est interrompue<br/><br/>'
									+ 'De verbinding met de AssurCard-server is onderbroken</br><br/>Die Verbindung zum AssurCard-Server wird unterbrochen', noTranslation: true,
								displayCountdown: true
							}));
						// default behavior
					}
				}
				// need to rethrow so angular can catch the error
				return throwError(() => error);
			})
		);
	}
}
